// extracted by mini-css-extract-plugin
module.exports = {"form__input":"FormInput_form__input__1ytuX"};